export default {_name:'Text.StatusChip',module:'Field',view:'Element/Text/StatusChip',webOptions:{xs:'auto'},mobileOptions:{ms:'auto'}}